export default __webpack_public_path__ + "img/Square_2.0ff609343aa0cbaa0e8aece75a7a57e3.jpg";